import { AxiosInstance } from 'axios';
import {
    PublishTaskPublishCreditInput,
    PublishTaskPublishManualInput,
    PublishTaskPublishPaymentInput,
    PublishTaskPublishQuotaInput,
} from './inputs';
import { TaskPublishRef } from './refs';

export default class TaskPublish {
    private basePath = '/api/task-publish';
    private http: AxiosInstance;

    constructor(http) {
        this.http = http;
    }

    // Perform manual task publish
    publishViaManual = async (input: PublishTaskPublishManualInput): Promise<TaskPublishRef> => {
        const { data } = await this.http.post(`${this.basePath}/manual`, input);

        return data;
    };

    // Perform payment task publish
    publishViaPayment = async (input: PublishTaskPublishPaymentInput): Promise<TaskPublishRef> => {
        const { data } = await this.http.post(`${this.basePath}/payment`, input);

        return data;
    };

    // Perform task publish based on the current user quota
    publishViaQuota = async (input: PublishTaskPublishQuotaInput): Promise<TaskPublishRef> => {
        const { data } = await this.http.post(`${this.basePath}/quota`, input);

        return data;
    };

    // Perform task credit task publish
    publishViaCredit = async (input: PublishTaskPublishCreditInput): Promise<TaskPublishRef> => {
        const { data } = await this.http.post(`${this.basePath}/credit`, input);

        return data;
    };

    // Attempt to finalize publish
    finalizePublish = async (id: ID): Promise<TaskPublishRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/attempt`);

        return data;
    };
}
